import React, { useState } from 'react';
import { Search, Calendar, Users, Filter, ArrowRight, Plane, Clock, DollarSign, Hotel, Car, MapPin, Star, Wifi, Coffee, Dumbbell, CheckCircle, AlertTriangle, X, NavigationIcon, ZapIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
export function BookingPage() {
  const {
    submitBooking
  } = useAppContext();
  const [activeTab, setActiveTab] = useState<'flights' | 'hotels' | 'cars' | 'rides'>('flights');
  const [tripType, setTripType] = useState('round-trip');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const showToast = (message: string) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(null), 3000);
  };
  const handleSelect = (item: any) => {
    setSelectedBooking(item);
    setShowConfirmation(true);
  };
  const handleSubmitBooking = () => {
    submitBooking(selectedBooking);
    setShowConfirmation(false);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);
  };
  const flights = [{
    id: 1,
    type: 'flight',
    airline: 'United Airlines',
    logo: 'UA',
    departure: '08:00 AM',
    arrival: '11:30 AM',
    duration: '5h 30m',
    stops: 'Non-stop',
    price: 450,
    class: 'Economy',
    policy: 'compliant'
  }, {
    id: 2,
    type: 'flight',
    airline: 'Delta',
    logo: 'DL',
    departure: '09:15 AM',
    arrival: '01:45 PM',
    duration: '6h 30m',
    stops: '1 Stop',
    price: 380,
    class: 'Economy',
    policy: 'compliant'
  }, {
    id: 3,
    type: 'flight',
    airline: 'American Airlines',
    logo: 'AA',
    departure: '10:30 AM',
    arrival: '02:00 PM',
    duration: '5h 30m',
    stops: 'Non-stop',
    price: 490,
    class: 'Economy',
    policy: 'compliant'
  }, {
    id: 4,
    type: 'flight',
    airline: 'United Airlines',
    logo: 'UA',
    departure: '02:00 PM',
    arrival: '05:30 PM',
    duration: '5h 30m',
    stops: 'Non-stop',
    price: 520,
    class: 'Business',
    policy: 'violation'
  }];
  const hotels = [{
    id: 101,
    type: 'hotel',
    name: 'Marriott Union Square',
    rating: 4,
    price: 280,
    distance: '0.3 mi',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant',
    amenities: ['wifi', 'breakfast', 'gym']
  }, {
    id: 102,
    type: 'hotel',
    name: 'Hilton Financial District',
    rating: 4,
    price: 310,
    distance: '0.8 mi',
    image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=300&q=80',
    policy: 'violation',
    amenities: ['wifi', 'gym']
  }, {
    id: 103,
    type: 'hotel',
    name: 'Holiday Inn Civic Center',
    rating: 3,
    price: 195,
    distance: '1.2 mi',
    image: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant',
    amenities: ['wifi', 'breakfast']
  }, {
    id: 104,
    type: 'hotel',
    name: 'The Ritz-Carlton',
    rating: 5,
    price: 520,
    distance: '0.5 mi',
    image: 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=300&q=80',
    policy: 'violation',
    amenities: ['wifi', 'breakfast', 'gym', 'pool']
  }];
  const cars = [{
    id: 201,
    type: 'car',
    category: 'Economy',
    model: 'Toyota Corolla',
    price: 45,
    vendor: 'Hertz',
    image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant'
  }, {
    id: 202,
    type: 'car',
    category: 'Compact',
    model: 'Honda Civic',
    price: 52,
    vendor: 'Enterprise',
    image: 'https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant'
  }, {
    id: 203,
    type: 'car',
    category: 'Midsize',
    model: 'Toyota Camry',
    price: 68,
    vendor: 'Avis',
    image: 'https://images.unsplash.com/photo-1619682817481-e994891cd1f5?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant'
  }, {
    id: 204,
    type: 'car',
    category: 'SUV',
    model: 'Ford Explorer',
    price: 95,
    vendor: 'National',
    image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=300&q=80',
    policy: 'violation'
  }];
  return <div className="space-y-6 relative" data-id="element-517">
      {showSuccess && <div className="fixed top-20 right-6 z-50 animate-in slide-in-from-top-2" data-id="element-518">
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-4 shadow-lg flex items-center gap-3" data-id="element-519">
            <CheckCircle className="h-5 w-5 text-emerald-600" data-id="element-520" />
            <div data-id="element-521">
              <p className="font-medium" data-id="element-522">Booking submitted for approval!</p>
              <Link to="/approvals" className="text-sm text-emerald-700 underline hover:text-emerald-900" data-id="element-523">
                View in Approvals
              </Link>
            </div>
            <button onClick={() => setShowSuccess(false)} className="ml-2 text-emerald-500 hover:text-emerald-700" data-id="element-524">
              <X className="h-4 w-4" data-id="element-525" />
            </button>
          </div>
        </div>}

      {toastMessage && <div className="fixed top-20 right-6 z-50 animate-in slide-in-from-top-2" data-id="element-526">
          <div className="bg-blue-50 border border-blue-200 text-blue-800 rounded-lg p-4 shadow-lg flex items-center gap-3" data-id="element-527">
            <Search className="h-5 w-5 text-blue-600 flex-shrink-0" data-id="element-528" />
            <p className="font-medium text-sm" data-id="element-529">{toastMessage}</p>
            <button onClick={() => setToastMessage(null)} className="ml-2 text-blue-500 hover:text-blue-700" data-id="element-530">
              <X className="h-4 w-4" data-id="element-531" />
            </button>
          </div>
        </div>}

      <div className="flex items-center justify-between" data-id="element-532">
        <h2 className="text-2xl font-bold text-slate-800" data-id="element-533">Book Travel</h2>
        <div className="flex gap-2" data-id="element-534">
          <button onClick={() => showToast('No saved searches yet. Search and save your preferences.')} className="rounded-lg bg-white border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-535">
            Saved Searches
          </button>
        </div>
      </div>

      {/* Main Tabs */}
      <div className="flex gap-4 border-b border-slate-200" data-id="element-536">
        <button onClick={() => setActiveTab('flights')} className={`pb-3 px-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'flights' ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-537">
          <Plane className="h-4 w-4" data-id="element-538" /> Flights
        </button>
        <button onClick={() => setActiveTab('hotels')} className={`pb-3 px-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'hotels' ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-539">
          <Hotel className="h-4 w-4" data-id="element-540" /> Hotels
        </button>
        <button onClick={() => setActiveTab('cars')} className={`pb-3 px-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'cars' ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-541">
          <Car className="h-4 w-4" data-id="element-542" /> Car Rental
        </button>
        <button onClick={() => setActiveTab('rides')} className={`pb-3 px-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'rides' ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-543">
          <NavigationIcon className="h-4 w-4" data-id="element-544" /> Rides
        </button>
      </div>

      {/* Search Forms */}
      <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-545">
        {activeTab === 'flights' && <>
            <div className="mb-6 flex gap-6 border-b border-slate-200 pb-4" data-id="element-546">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-547">
                <input type="radio" name="tripType" checked={tripType === 'round-trip'} onChange={() => setTripType('round-trip')} className="text-blue-600 focus:ring-blue-500" data-id="element-548" />
                <span className="text-sm font-medium text-slate-700" data-id="element-549">
                  Round Trip
                </span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-550">
                <input type="radio" name="tripType" checked={tripType === 'one-way'} onChange={() => setTripType('one-way')} className="text-blue-600 focus:ring-blue-500" data-id="element-551" />
                <span className="text-sm font-medium text-slate-700" data-id="element-552">
                  One Way
                </span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-553">
                <input type="radio" name="tripType" checked={tripType === 'multi-city'} onChange={() => setTripType('multi-city')} className="text-blue-600 focus:ring-blue-500" data-id="element-554" />
                <span className="text-sm font-medium text-slate-700" data-id="element-555">
                  Multi-City
                </span>
              </label>
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-12" data-id="element-556">
              <div className="md:col-span-3" data-id="element-557">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-558">
                  From
                </label>
                <div className="relative" data-id="element-559">
                  <Plane className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-560" />
                  <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900 focus:border-blue-500 focus:ring-blue-500" placeholder="Origin" defaultValue="New York (JFK)" data-id="element-561" />
                </div>
              </div>
              <div className="md:col-span-3" data-id="element-562">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-563">
                  To
                </label>
                <div className="relative" data-id="element-564">
                  <Plane className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 transform rotate-90" data-id="element-565" />
                  <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900 focus:border-blue-500 focus:ring-blue-500" placeholder="Destination" defaultValue="London (LHR)" data-id="element-566" />
                </div>
              </div>
              <div className="md:col-span-2" data-id="element-567">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-568">
                  Departure
                </label>
                <div className="relative" data-id="element-569">
                  <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-570" />
                  <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-571" />
                </div>
              </div>
              <div className="md:col-span-2" data-id="element-572">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-573">
                  Return
                </label>
                <div className="relative" data-id="element-574">
                  <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-575" />
                  <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-576" />
                </div>
              </div>
              <div className="md:col-span-2" data-id="element-577">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-578">
                  Travelers
                </label>
                <div className="relative" data-id="element-579">
                  <Users className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-580" />
                  <select className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-581">
                    <option data-id="element-582">1 Adult</option>
                    <option data-id="element-583">2 Adults</option>
                  </select>
                </div>
              </div>
            </div>
          </>}

        {activeTab === 'hotels' && <div className="grid grid-cols-1 gap-4 md:grid-cols-12" data-id="element-584">
            <div className="md:col-span-4" data-id="element-585">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-586">
                Destination
              </label>
              <div className="relative" data-id="element-587">
                <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-588" />
                <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" placeholder="City, Hotel, or Address" defaultValue="San Francisco, CA" data-id="element-589" />
              </div>
            </div>
            <div className="md:col-span-3" data-id="element-590">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-591">
                Check-in
              </label>
              <div className="relative" data-id="element-592">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-593" />
                <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-594" />
              </div>
            </div>
            <div className="md:col-span-3" data-id="element-595">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-596">
                Check-out
              </label>
              <div className="relative" data-id="element-597">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-598" />
                <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-599" />
              </div>
            </div>
            <div className="md:col-span-2" data-id="element-600">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-601">
                Guests
              </label>
              <div className="relative" data-id="element-602">
                <Users className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-603" />
                <select className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-604">
                  <option data-id="element-605">1 Room, 1 Guest</option>
                  <option data-id="element-606">1 Room, 2 Guests</option>
                </select>
              </div>
            </div>
          </div>}

        {activeTab === 'cars' && <div className="grid grid-cols-1 gap-4 md:grid-cols-12" data-id="element-607">
            <div className="md:col-span-4" data-id="element-608">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-609">
                Pickup Location
              </label>
              <div className="relative" data-id="element-610">
                <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-611" />
                <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" placeholder="Airport or City" defaultValue="SFO Airport" data-id="element-612" />
              </div>
            </div>
            <div className="md:col-span-4" data-id="element-613">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-614">
                Pickup Date & Time
              </label>
              <div className="relative" data-id="element-615">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-616" />
                <input type="datetime-local" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-617" />
              </div>
            </div>
            <div className="md:col-span-4" data-id="element-618">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-619">
                Return Date & Time
              </label>
              <div className="relative" data-id="element-620">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-621" />
                <input type="datetime-local" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-622" />
              </div>
            </div>
          </div>}

        {activeTab === 'rides' && <div className="grid grid-cols-1 gap-4 md:grid-cols-12" data-id="element-623">
            <div className="md:col-span-4" data-id="element-624">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-625">
                Pickup Location
              </label>
              <div className="relative" data-id="element-626">
                <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-emerald-500" data-id="element-627" />
                <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900 focus:border-blue-500 focus:ring-blue-500" placeholder="Airport, hotel, or address" defaultValue="SFO International Airport" data-id="element-628" />
              </div>
            </div>
            <div className="md:col-span-4" data-id="element-629">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-630">
                Dropoff Location
              </label>
              <div className="relative" data-id="element-631">
                <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-red-500" data-id="element-632" />
                <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900 focus:border-blue-500 focus:ring-blue-500" placeholder="Destination address" defaultValue="Marriott Union Square, SF" data-id="element-633" />
              </div>
            </div>
            <div className="md:col-span-2" data-id="element-634">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-635">
                Date & Time
              </label>
              <div className="relative" data-id="element-636">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-637" />
                <input type="datetime-local" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-638" />
              </div>
            </div>
            <div className="md:col-span-2" data-id="element-639">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-640">
                Ride Type
              </label>
              <select className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 text-slate-900" data-id="element-641">
                <option data-id="element-642">Airport Transfer</option>
                <option data-id="element-643">City Ride</option>
                <option data-id="element-644">Intercity</option>
              </select>
            </div>
          </div>}

        <div className="mt-6 flex justify-end" data-id="element-645">
          <button className="flex items-center rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700" data-id="element-646">
            <Search className="mr-2 h-4 w-4" data-id="element-647" />
            Search{' '}
            {activeTab === 'flights' ? 'Flights' : activeTab === 'hotels' ? 'Hotels' : activeTab === 'cars' ? 'Cars' : 'Rides'}
          </button>
        </div>
      </div>

      {/* Results */}
      {activeTab !== 'rides' ? <div className="grid grid-cols-1 gap-6 lg:grid-cols-4" data-id="element-648">
          <div className="space-y-6 lg:col-span-1" data-id="element-649">
            <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-650">
              <div className="mb-4 flex items-center justify-between" data-id="element-651">
                <h3 className="font-semibold text-slate-800" data-id="element-652">Filters</h3>
                <button className="text-xs text-blue-600 hover:underline" data-id="element-653">
                  Reset
                </button>
              </div>
              <div className="space-y-4" data-id="element-654">
                <div data-id="element-655">
                  <h4 className="mb-2 text-sm font-medium text-slate-700" data-id="element-656">
                    Price Range
                  </h4>
                  <input type="range" className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer" data-id="element-657" />
                </div>
                <div className="border-t border-slate-200 pt-4" data-id="element-658">
                  <h4 className="mb-2 text-sm font-medium text-slate-700" data-id="element-659">
                    Policy
                  </h4>
                  <label className="flex items-center" data-id="element-660">
                    <input type="checkbox" className="h-4 w-4 rounded border-slate-300 text-blue-600" defaultChecked data-id="element-661" />
                    <span className="ml-2 text-sm text-slate-600" data-id="element-662">
                      Within Policy Only
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-4" data-id="element-663">
            {activeTab === 'flights' && flights.map(flight => <div key={flight.id} className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-blue-300 hover:shadow-md" data-id="element-664">
                  <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-665">
                    <div className="flex items-center gap-4 sm:w-1/4" data-id="element-666">
                      <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-slate-100 font-bold text-slate-600" data-id="element-667">
                        {flight.logo}
                      </div>
                      <div data-id="element-668">
                        <h4 className="font-semibold text-slate-900" data-id="element-669">
                          {flight.airline}
                        </h4>
                        <span className="text-xs text-slate-500" data-id="element-670">
                          {flight.class}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-1 items-center justify-center gap-4 sm:gap-8" data-id="element-671">
                      <div className="text-center" data-id="element-672">
                        <p className="text-lg font-bold text-slate-900" data-id="element-673">
                          {flight.departure}
                        </p>
                        <p className="text-xs text-slate-500" data-id="element-674">JFK</p>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-675">
                        <p className="mb-1 text-xs text-slate-500" data-id="element-676">
                          {flight.duration}
                        </p>
                        <div className="flex w-24 items-center" data-id="element-677">
                          <div className="h-px w-full bg-slate-300" data-id="element-678"></div>
                          <Plane className="mx-1 h-3 w-3 text-slate-400" data-id="element-679" />
                          <div className="h-px w-full bg-slate-300" data-id="element-680"></div>
                        </div>
                        <p className="mt-1 text-xs font-medium text-slate-600" data-id="element-681">
                          {flight.stops}
                        </p>
                      </div>
                      <div className="text-center" data-id="element-682">
                        <p className="text-lg font-bold text-slate-900" data-id="element-683">
                          {flight.arrival}
                        </p>
                        <p className="text-xs text-slate-500" data-id="element-684">LHR</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between gap-4 border-t border-slate-100 pt-4 sm:w-1/4 sm:flex-col sm:border-l sm:border-t-0 sm:pl-6 sm:pt-0" data-id="element-685">
                      <div className="text-right sm:text-center" data-id="element-686">
                        <p className="text-2xl font-bold text-slate-900" data-id="element-687">
                          ${flight.price}
                        </p>
                        {flight.policy === 'violation' && <span className="text-xs text-amber-600 font-medium" data-id="element-688">
                            Exceeds Cap
                          </span>}
                      </div>
                      <button onClick={() => handleSelect(flight)} className="rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 sm:w-full" data-id="element-689">
                        Select
                      </button>
                    </div>
                  </div>
                </div>)}

            {activeTab === 'hotels' && hotels.map(hotel => <div key={hotel.id} className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-blue-300 hover:shadow-md" data-id="element-690">
                  <div className="flex flex-col sm:flex-row gap-6" data-id="element-691">
                    <div className="h-32 w-full sm:w-48 rounded-lg bg-slate-200 bg-cover bg-center flex-shrink-0" style={{
              backgroundImage: `url(${hotel.image})`
            }} data-id="element-692"></div>
                    <div className="flex-1 flex flex-col justify-between" data-id="element-693">
                      <div data-id="element-694">
                        <div className="flex justify-between items-start" data-id="element-695">
                          <div data-id="element-696">
                            <h4 className="font-bold text-lg text-slate-900" data-id="element-697">
                              {hotel.name}
                            </h4>
                            <div className="flex items-center gap-1 text-amber-400 text-sm" data-id="element-698">
                              {[...Array(hotel.rating)].map((_, i) => <Star key={i} className="h-3 w-3 fill-current" data-id="element-699" />)}
                            </div>
                            <p className="text-sm text-slate-500 mt-1" data-id="element-700">
                              {hotel.distance} from venue
                            </p>
                          </div>
                          <div className="text-right" data-id="element-701">
                            <p className="text-2xl font-bold text-slate-900" data-id="element-702">
                              ${hotel.price}
                            </p>
                            <p className="text-xs text-slate-500" data-id="element-703">per night</p>
                          </div>
                        </div>
                        <div className="flex gap-3 mt-3" data-id="element-704">
                          {hotel.amenities.includes('wifi') && <Wifi className="h-4 w-4 text-slate-400" data-id="element-705" />}
                          {hotel.amenities.includes('breakfast') && <Coffee className="h-4 w-4 text-slate-400" data-id="element-706" />}
                          {hotel.amenities.includes('gym') && <Dumbbell className="h-4 w-4 text-slate-400" data-id="element-707" />}
                        </div>
                      </div>
                      <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100" data-id="element-708">
                        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${hotel.policy === 'compliant' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-709">
                          {hotel.policy === 'compliant' ? 'Within Policy' : 'Exceeds Cap'}
                        </span>
                        <button onClick={() => handleSelect(hotel)} className="rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700" data-id="element-710">
                          Select Room
                        </button>
                      </div>
                    </div>
                  </div>
                </div>)}

            {activeTab === 'cars' && cars.map(car => <div key={car.id} className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-blue-300 hover:shadow-md" data-id="element-711">
                  <div className="flex flex-col sm:flex-row gap-6 items-center" data-id="element-712">
                    <div className="h-24 w-full sm:w-40 rounded-lg bg-slate-100 bg-cover bg-center flex-shrink-0" style={{
              backgroundImage: `url(${car.image})`
            }} data-id="element-713"></div>
                    <div className="flex-1 w-full" data-id="element-714">
                      <div className="flex justify-between items-start" data-id="element-715">
                        <div data-id="element-716">
                          <p className="text-xs font-bold text-slate-500 uppercase tracking-wide" data-id="element-717">
                            {car.category}
                          </p>
                          <h4 className="font-bold text-lg text-slate-900" data-id="element-718">
                            {car.model}
                          </h4>
                          <p className="text-sm text-slate-500" data-id="element-719">
                            Provided by {car.vendor}
                          </p>
                        </div>
                        <div className="text-right" data-id="element-720">
                          <p className="text-2xl font-bold text-slate-900" data-id="element-721">
                            ${car.price}
                          </p>
                          <p className="text-xs text-slate-500" data-id="element-722">per day</p>
                        </div>
                      </div>
                      <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100" data-id="element-723">
                        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${car.policy === 'compliant' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-724">
                          {car.policy === 'compliant' ? 'Within Policy' : 'Exceeds Cap'}
                        </span>
                        <button onClick={() => handleSelect(car)} className="rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700" data-id="element-725">
                          Select Car
                        </button>
                      </div>
                    </div>
                  </div>
                </div>)}
          </div>
        </div> /* Ride-Hailing Results */ : <div className="space-y-6" data-id="element-726">
          <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-727">
            <NavigationIcon className="h-4 w-4" data-id="element-728" />
            <span data-id="element-729">
              SFO International Airport → Marriott Union Square • Est. 25 min
            </span>
          </div>

          {/* Uber for Business */}
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-730">
            <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100 bg-slate-50" data-id="element-731">
              <div className="h-10 w-10 rounded-full bg-black flex items-center justify-center text-white font-bold text-lg" data-id="element-732">
                U
              </div>
              <div className="flex-1" data-id="element-733">
                <h3 className="font-bold text-slate-900" data-id="element-734">Uber for Business</h3>
                <p className="text-xs text-slate-500" data-id="element-735">
                  ETA: 3-5 min • Corporate account linked
                </p>
              </div>
              <span className="px-2.5 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700" data-id="element-736">
                CONNECTED
              </span>
            </div>
            <div className="divide-y divide-slate-100" data-id="element-737">
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-738">
                <div className="flex items-center gap-4" data-id="element-739">
                  <div className="h-10 w-16 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-740">
                    <Car className="h-5 w-5 text-slate-500" data-id="element-741" />
                  </div>
                  <div data-id="element-742">
                    <h4 className="font-semibold text-slate-900" data-id="element-743">UberX</h4>
                    <p className="text-xs text-slate-500" data-id="element-744">4 seats • Standard</p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-745">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-100 text-emerald-700" data-id="element-746">
                    Within Policy
                  </span>
                  <div className="text-right" data-id="element-747">
                    <p className="font-bold text-slate-900" data-id="element-748">$18-24</p>
                    <p className="text-[10px] text-slate-500" data-id="element-749">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 301,
                type: 'ride',
                name: 'Uber for Business — UberX',
                price: 18,
                policy: 'compliant',
                vendor: 'Uber'
              })} className="rounded-lg bg-black px-4 py-2 text-xs font-semibold text-white hover:bg-gray-800 transition-colors" data-id="element-750">
                    Book Ride
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-751">
                <div className="flex items-center gap-4" data-id="element-752">
                  <div className="h-10 w-16 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-753">
                    <Car className="h-5 w-5 text-slate-500" data-id="element-754" />
                  </div>
                  <div data-id="element-755">
                    <h4 className="font-semibold text-slate-900" data-id="element-756">
                      Uber Comfort
                    </h4>
                    <p className="text-xs text-slate-500" data-id="element-757">
                      4 seats • Extra legroom
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-758">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-100 text-emerald-700" data-id="element-759">
                    Within Policy
                  </span>
                  <div className="text-right" data-id="element-760">
                    <p className="font-bold text-slate-900" data-id="element-761">$28-35</p>
                    <p className="text-[10px] text-slate-500" data-id="element-762">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 302,
                type: 'ride',
                name: 'Uber for Business — Comfort',
                price: 28,
                policy: 'compliant',
                vendor: 'Uber'
              })} className="rounded-lg bg-black px-4 py-2 text-xs font-semibold text-white hover:bg-gray-800 transition-colors" data-id="element-763">
                    Book Ride
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-764">
                <div className="flex items-center gap-4" data-id="element-765">
                  <div className="h-10 w-16 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-766">
                    <Car className="h-5 w-5 text-slate-500" data-id="element-767" />
                  </div>
                  <div data-id="element-768">
                    <h4 className="font-semibold text-slate-900" data-id="element-769">Uber Black</h4>
                    <p className="text-xs text-slate-500" data-id="element-770">
                      4 seats • Premium sedan
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-771">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-amber-100 text-amber-700" data-id="element-772">
                    Exceeds Cap
                  </span>
                  <div className="text-right" data-id="element-773">
                    <p className="font-bold text-slate-900" data-id="element-774">$45-60</p>
                    <p className="text-[10px] text-slate-500" data-id="element-775">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 303,
                type: 'ride',
                name: 'Uber for Business — Black',
                price: 45,
                policy: 'violation',
                vendor: 'Uber'
              })} className="rounded-lg bg-black px-4 py-2 text-xs font-semibold text-white hover:bg-gray-800 transition-colors" data-id="element-776">
                    Book Ride
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Bolt */}
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-777">
            <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100 bg-slate-50" data-id="element-778">
              <div className="h-10 w-10 rounded-full bg-emerald-500 flex items-center justify-center text-white font-bold text-lg" data-id="element-779">
                B
              </div>
              <div className="flex-1" data-id="element-780">
                <h3 className="font-bold text-slate-900" data-id="element-781">Bolt</h3>
                <p className="text-xs text-slate-500" data-id="element-782">
                  ETA: 2-4 min • Best value rides
                </p>
              </div>
              <span className="px-2.5 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700" data-id="element-783">
                CONNECTED
              </span>
            </div>
            <div className="divide-y divide-slate-100" data-id="element-784">
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-785">
                <div className="flex items-center gap-4" data-id="element-786">
                  <div className="h-10 w-16 rounded-lg bg-emerald-50 flex items-center justify-center" data-id="element-787">
                    <Car className="h-5 w-5 text-emerald-600" data-id="element-788" />
                  </div>
                  <div data-id="element-789">
                    <h4 className="font-semibold text-slate-900" data-id="element-790">Bolt</h4>
                    <p className="text-xs text-slate-500" data-id="element-791">4 seats • Standard</p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-792">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-100 text-emerald-700" data-id="element-793">
                    Within Policy
                  </span>
                  <div className="text-right" data-id="element-794">
                    <p className="font-bold text-slate-900" data-id="element-795">$15-20</p>
                    <p className="text-[10px] text-slate-500" data-id="element-796">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 304,
                type: 'ride',
                name: 'Bolt — Standard',
                price: 15,
                policy: 'compliant',
                vendor: 'Bolt'
              })} className="rounded-lg bg-emerald-500 px-4 py-2 text-xs font-semibold text-white hover:bg-emerald-600 transition-colors" data-id="element-797">
                    Book Ride
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-798">
                <div className="flex items-center gap-4" data-id="element-799">
                  <div className="h-10 w-16 rounded-lg bg-emerald-50 flex items-center justify-center" data-id="element-800">
                    <Car className="h-5 w-5 text-emerald-600" data-id="element-801" />
                  </div>
                  <div data-id="element-802">
                    <h4 className="font-semibold text-slate-900" data-id="element-803">
                      Bolt Comfort
                    </h4>
                    <p className="text-xs text-slate-500" data-id="element-804">
                      4 seats • Newer cars
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-805">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-100 text-emerald-700" data-id="element-806">
                    Within Policy
                  </span>
                  <div className="text-right" data-id="element-807">
                    <p className="font-bold text-slate-900" data-id="element-808">$25-32</p>
                    <p className="text-[10px] text-slate-500" data-id="element-809">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 305,
                type: 'ride',
                name: 'Bolt — Comfort',
                price: 25,
                policy: 'compliant',
                vendor: 'Bolt'
              })} className="rounded-lg bg-emerald-500 px-4 py-2 text-xs font-semibold text-white hover:bg-emerald-600 transition-colors" data-id="element-810">
                    Book Ride
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-811">
                <div className="flex items-center gap-4" data-id="element-812">
                  <div className="h-10 w-16 rounded-lg bg-emerald-50 flex items-center justify-center" data-id="element-813">
                    <Car className="h-5 w-5 text-emerald-600" data-id="element-814" />
                  </div>
                  <div data-id="element-815">
                    <h4 className="font-semibold text-slate-900" data-id="element-816">Bolt XL</h4>
                    <p className="text-xs text-slate-500" data-id="element-817">
                      6 seats • Group rides
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-818">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-100 text-emerald-700" data-id="element-819">
                    Within Policy
                  </span>
                  <div className="text-right" data-id="element-820">
                    <p className="font-bold text-slate-900" data-id="element-821">$35-45</p>
                    <p className="text-[10px] text-slate-500" data-id="element-822">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 306,
                type: 'ride',
                name: 'Bolt — XL',
                price: 35,
                policy: 'compliant',
                vendor: 'Bolt'
              })} className="rounded-lg bg-emerald-500 px-4 py-2 text-xs font-semibold text-white hover:bg-emerald-600 transition-colors" data-id="element-823">
                    Book Ride
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* InDrive */}
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-824">
            <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100 bg-slate-50" data-id="element-825">
              <div className="h-10 w-10 rounded-full bg-purple-600 flex items-center justify-center text-white font-bold text-sm" data-id="element-826">
                iD
              </div>
              <div className="flex-1" data-id="element-827">
                <h3 className="font-bold text-slate-900" data-id="element-828">InDrive</h3>
                <p className="text-xs text-slate-500" data-id="element-829">
                  ETA: 5-8 min • Negotiate your fare
                </p>
              </div>
              <span className="px-2.5 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700" data-id="element-830">
                CONNECTED
              </span>
            </div>
            <div className="divide-y divide-slate-100" data-id="element-831">
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-832">
                <div className="flex items-center gap-4" data-id="element-833">
                  <div className="h-10 w-16 rounded-lg bg-purple-50 flex items-center justify-center" data-id="element-834">
                    <Car className="h-5 w-5 text-purple-600" data-id="element-835" />
                  </div>
                  <div data-id="element-836">
                    <h4 className="font-semibold text-slate-900" data-id="element-837">Economy</h4>
                    <p className="text-xs text-slate-500" data-id="element-838">
                      4 seats • Best price
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-839">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-100 text-emerald-700" data-id="element-840">
                    Within Policy
                  </span>
                  <div className="text-right" data-id="element-841">
                    <p className="font-bold text-slate-900" data-id="element-842">$12-18</p>
                    <p className="text-[10px] text-slate-500" data-id="element-843">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 307,
                type: 'ride',
                name: 'InDrive — Economy',
                price: 12,
                policy: 'compliant',
                vendor: 'InDrive'
              })} className="rounded-lg bg-purple-600 px-4 py-2 text-xs font-semibold text-white hover:bg-purple-700 transition-colors" data-id="element-844">
                    Book Ride
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors" data-id="element-845">
                <div className="flex items-center gap-4" data-id="element-846">
                  <div className="h-10 w-16 rounded-lg bg-purple-50 flex items-center justify-center" data-id="element-847">
                    <Car className="h-5 w-5 text-purple-600" data-id="element-848" />
                  </div>
                  <div data-id="element-849">
                    <h4 className="font-semibold text-slate-900" data-id="element-850">Comfort</h4>
                    <p className="text-xs text-slate-500" data-id="element-851">4 seats • Premium</p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-852">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-emerald-100 text-emerald-700" data-id="element-853">
                    Within Policy
                  </span>
                  <div className="text-right" data-id="element-854">
                    <p className="font-bold text-slate-900" data-id="element-855">$22-28</p>
                    <p className="text-[10px] text-slate-500" data-id="element-856">est. fare</p>
                  </div>
                  <button onClick={() => handleSelect({
                id: 308,
                type: 'ride',
                name: 'InDrive — Comfort',
                price: 22,
                policy: 'compliant',
                vendor: 'InDrive'
              })} className="rounded-lg bg-purple-600 px-4 py-2 text-xs font-semibold text-white hover:bg-purple-700 transition-colors" data-id="element-857">
                    Book Ride
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* Booking Confirmation Modal */}
      {showConfirmation && selectedBooking && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm" data-id="element-858">
          <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl animate-in fade-in zoom-in-95 duration-200" data-id="element-859">
            <div className="flex items-center justify-between mb-6" data-id="element-860">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-861">
                Confirm Booking
              </h3>
              <button onClick={() => setShowConfirmation(false)} className="rounded-full p-1 hover:bg-slate-100" data-id="element-862">
                <X className="h-5 w-5 text-slate-500" data-id="element-863" />
              </button>
            </div>
            <div className="bg-slate-50 rounded-xl p-4 mb-6 border border-slate-200" data-id="element-864">
              <div className="flex gap-4" data-id="element-865">
                <div className="h-16 w-16 rounded-lg bg-white border border-slate-200 flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-866">
                  {selectedBooking.image ? <img src={selectedBooking.image} alt="" className="h-full w-full object-cover" data-id="element-867" /> : selectedBooking.type === 'ride' ? <NavigationIcon className="h-6 w-6 text-blue-500" data-id="element-868" /> : <span className="font-bold text-slate-400" data-id="element-869">
                      {selectedBooking.logo || <Plane data-id="element-870" />}
                    </span>}
                </div>
                <div data-id="element-871">
                  <h4 className="font-bold text-slate-900" data-id="element-872">
                    {selectedBooking.name || selectedBooking.model || selectedBooking.airline}
                  </h4>
                  <p className="text-sm text-slate-500" data-id="element-873">
                    {selectedBooking.vendor || selectedBooking.description || 'Standard Rate'}
                  </p>
                  <div className="mt-2 flex items-center gap-2" data-id="element-874">
                    {selectedBooking.policy === 'compliant' ? <span className="flex items-center text-xs font-medium text-emerald-700" data-id="element-875">
                        <CheckCircle className="h-3 w-3 mr-1" data-id="element-876" /> Within Policy
                      </span> : <span className="flex items-center text-xs font-medium text-amber-700" data-id="element-877">
                        <AlertTriangle className="h-3 w-3 mr-1" data-id="element-878" /> Requires
                        Approval
                      </span>}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center mb-8 pb-6 border-b border-slate-100" data-id="element-879">
              <span className="text-slate-600" data-id="element-880">Total Estimated Cost</span>
              <span className="text-2xl font-bold text-slate-900" data-id="element-881">
                ${selectedBooking.price}
              </span>
            </div>
            <div className="flex gap-3" data-id="element-882">
              <button onClick={() => setShowConfirmation(false)} className="flex-1 rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-883">
                Cancel
              </button>
              <button onClick={handleSubmitBooking} className="flex-1 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700" data-id="element-884">
                Submit for Approval
              </button>
            </div>
          </div>
        </div>}
    </div>;
}